import { render, staticRenderFns } from "./CreateModal.vue?vue&type=template&id=ddccb190&"
import script from "./CreateModal.vue?vue&type=script&lang=js&"
export * from "./CreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddccb190')) {
      api.createRecord('ddccb190', component.options)
    } else {
      api.reload('ddccb190', component.options)
    }
    module.hot.accept("./CreateModal.vue?vue&type=template&id=ddccb190&", function () {
      api.rerender('ddccb190', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/illicit-barcode/expiration-campaign/CreateModal.vue"
export default component.exports